module.exports = __webpack_public_path__ + "img/2_adidas.87eda60a.jpg";